// 判断babel是否重复 解决乾坤报错
if (!window._babelPolyfill) {
  require('babel-polyfill')
}

import Vue from 'vue'
import ElementUI from 'element-ui'
// import './styles/element-variables.scss'
import App from './App'
import router from './router'
import store from './store'
import '@/icons' // icon
import '@/permission' // 权限
import jsencrypt from 'jsencrypt'
import axios from 'axios'
// process.env.NODE_ENV === 'development' && require('./mock')
// import './mock' // 模拟数据
import VueJsonp from 'vue-jsonp'
import moment from 'moment'

import init from '@/lib/init'
import i18n from '@/lib/i18'
import domainApi from '@/api/domain'
import domainConfig from '../config/config.json'
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'

// 输入框数据自动去除头尾空格
ElementUI.Input.methods.handleInput = function(event) {
  const value = event.target.value.trim()
  this.$emit('input', value)
  // this.setCurrentValue(value)
}
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})
Vue.use(init)
Vue.use(VueJsonp)
Vue.config.productionTip = false
Vue.prototype.$jsencrypt = new jsencrypt.JSEncrypt()
Vue.prototype.$axios = axios
Vue.prototype.$moment = moment
Vue.use(ViewUI)
Vue.mixin({
  mounted() {
    const nodeList = document.querySelectorAll('label.el-form-item__label')
    const array = [...nodeList]

    for (let i = 0; i < array.length; i++) {
      array[i].setAttribute('title', array[i].textContent)
    }
  }
})
if (window.__POWERED_BY_QIANKUN__) {
  // eslint-disable-next-line no-undef
  __webpack_public_path__ = window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__
}
let instance = null

async function render(props) {
  Vue.config.productionTip = false
  Vue.prototype.mainProps = props
  window.Vue = Vue

  // 初始化 config
  if (window.location.href.includes('localhost')) {
    store.commit('permission/SET_DOMAIN', domainConfig)
    // 初始化 Vue
    instance = new Vue({
      el: '#app',
      router,
      store,
      i18n,
      template: '<App/>',
      components: { App }
    }).$mount('#app')
  } else {
    domainApi.getDomain().then(res => {
      store.commit('permission/SET_DOMAIN', res)
      // 初始化 Vue
      instance = new Vue({
        el: '#app',
        router,
        store,
        i18n,
        template: '<App/>',
        components: { App }
      }).$mount('#app')
    })
  }
}
if (!window.__POWERED_BY_QIANKUN__) {
  render()
}

export async function bootstrap() {
  console.log('[vue] vue app bootstraped')
}

export async function mount(props) {
  props.onGlobalStateChange((state, prev) => {
    console.log('子应用中收到状态：', state, prev)
  })
  props.setGlobalState({ a: 2222222 })

  props.onGlobalStateChange((state, prev) => {
    // state: 变更后的状态; prev 变更前的状态
    console.log('子应用中：', state, prev)
  })
  render(props)
  // let state = {a:3}
  // props.setGlobalState(state)
}

export async function unmount() {
  console.log('子应用销毁')
  instance.$destroy()
  instance = null
  window.Vue = null
}



// WEBPACK FOOTER //
// ./src/main.js